import { registerCollisionAnimation } from './CollisionAnimationRegistry';

registerCollisionAnimation('DNA_HELIX', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  const strands = 2;
  const points = 10;
  const radius = e.radius * (1 + progress * 2);
  
  for (let s = 0; s < strands; s++) {
    ctx.beginPath();
    ctx.strokeStyle = determineColor(s, strands);
    ctx.lineWidth = 2 * (1 - progress);
    
    for (let i = 0; i <= points; i++) {
        const t = i / points;
        const angle = t * Math.PI * 2 + progress * Math.PI + (s * Math.PI);
        const x = e.pos.x + Math.cos(angle) * radius * t;
        const y = e.pos.y + Math.sin(angle) * (radius * 0.5) + (t - 0.5) * radius * 2;
        
        if (i === 0) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
        
        // Connect strands
        if (s === 0 && i % 2 === 0) {
            const angle2 = t * Math.PI * 2 + progress * Math.PI + Math.PI;
            const x2 = e.pos.x + Math.cos(angle2) * radius * t;
            const y2 = e.pos.y + Math.sin(angle2) * (radius * 0.5) + (t - 0.5) * radius * 2;
            ctx.save();
            ctx.beginPath();
            ctx.moveTo(x, y);
            ctx.lineTo(x2, y2);
            ctx.globalAlpha = (1 - progress) * 0.5;
            ctx.stroke();
            ctx.restore();
        }
    }
    ctx.stroke();
  }
});
